import $ from 'jquery';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('#form_view');
    this.render();
  }

  @on({ event: 'change', selector: '.zip-code-field' })
  onChangeUserZipCode() {
    this.render();
  }

  @on({ event: 'blur', selector: '.zip-code-field' })
  onBlurZipCode(event: JQuery.BlurEvent) {
    const original_zip_code = $(event.target).val();
    if (original_zip_code.length === 0) {
      return;
    }
    let formatted_zip_code = original_zip_code
      .replace('ー', '-')
      .replace('－', '-')
      .replace('−', '-')
      .replace('ｰ', '-')
      .replace(/[０-９]/g, (s: string) =>
        String.fromCharCode(s.charCodeAt(0) - 0xfee0),
      );
    if (/^\d*$/.test(formatted_zip_code) === true) {
      if (formatted_zip_code.length >= 4) {
        formatted_zip_code =
          formatted_zip_code.substr(0, 3) + '-' + formatted_zip_code.substr(3);
      }
    }
    if (formatted_zip_code !== original_zip_code) {
      $(event.target).val(formatted_zip_code).change();
    }
  }

  @on({ event: 'click', selector: '#delete-beneficial-owner' })
  deleteBeneficialOwner(event: JQuery.ClickEvent) {
    event.stopPropagation();

    const index = $(event.target).data('index');
    $(`#beneficial-owner-${index}`).remove();
    $(`#investor_corporate_beneficial_owners_attributes_${index}__destroy`).val(
      'true',
    );

    $('#add-beneficial-owner')[0].dataset.params = `index=${index - 1}`;

    this.render();
  }

  @on({ event: 'change', selector: '.relationship-with-corporation' })
  onChangeRelationshipWithCorporation(event: JQuery.ChangeEvent) {
    this.toggleRelationshipWithCorporationSubFields(event.target);
  }

  toggleRelationshipWithCorporationSubFields(target: HTMLElement) {
    const value = $(target).val();
    const index = this.getIndex(target);
    const position = $(`#beneficial-owner-${index}-position`);
    const ownershipRatio = $(`#beneficial-owner-${index}-ownership-ratio`);
    if (value === 'influence') {
      position.removeClass('d-none');
      ownershipRatio.addClass('d-none');
      this.togglePositionDescription(target);
    } else if (value === 'voting') {
      position.addClass('d-none');
      ownershipRatio.removeClass('d-none');
    } else {
      position.addClass('d-none');
      ownershipRatio.addClass('d-none');
    }
  }

  getIndex(target: HTMLElement) {
    const parent = this.parent(target);
    // data-index は _beneficial_owner.html.erb で数値をレンダリングしており、jQuery の .data() が number に変換する
    const index = parent.data('index') as number;
    return index;
  }

  parent(target: HTMLElement) {
    return $(target).parents('.beneficial-owner');
  }

  @on({ event: 'change', selector: '.position-field:radio' })
  onChangePositionField(event: JQuery.ChangeEvent) {
    this.togglePositionDescription(event.target);
  }

  togglePositionDescription(target: HTMLElement) {
    const value = $(target).val();
    const parent = $(target).parents('.beneficial-owner');
    const description = parent.find('.position-description-field');

    if (value === 'other') {
      description.show();
    } else {
      description.hide();
    }
  }

  render() {
    if ($('.beneficial-owner').length >= 2) {
      // 削除ボタン設置
      const index = $('.beneficial-owner').length - 1; // 0からインデックスが始まるので -1 する
      const deleteButton = `<button id="delete-beneficial-owner" class="btn btn-danger" data-index="${index}">削除する</button>`;
      $('.delete-beneficial-owner-area').last().html(deleteButton);
    }

    $('.relationship-with-corporation').each((_, dom) => {
      this.toggleRelationshipWithCorporationSubFields(dom);
    });

    $('.position-field:checked').each((_, dom) =>
      this.togglePositionDescription(dom),
    );
  }
}
